export default "__VITE_ASSET__e8dde0e4__"